// extracted by mini-css-extract-plugin
module.exports = {"titshare":"titshare-y5WG2KH8","vertical":"vertical-1w7oPXV8","boxhidden":"boxhidden-1kB7KrjE"};